import { useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../styles/section-working.css";

import acc from "../../assets/1-Inscrivez-vous.png";
import look from "../../assets/2-Choisissez les jours.png";
import chef from "../../assets/3-Recevez et préparez.png";
import deli from "../../assets/4-Apprêtez les commandes.jpg";

import { useSelector } from "react-redux";
import { t } from "../../translations";

const SectionWorkingChef = () => {
  const lang = useSelector((state) => state.lang);

  useEffect(() => {}, []);

  return (
    <div className="section-working">
      <h2>{t("section_working_chef.title", lang)}</h2>
      <div className="section-element">
        {[
          {
            text: t("section_working_chef.step1", lang),
            img: acc
          },
          {
            text: t("section_working_chef.step2", lang),
            img: look
          },
          {
            text: t("section_working_chef.step3", lang),
            img: chef
          },
          {
            text: t("section_working_chef.step4", lang),
            img: deli
          }
        ].map((item) => (
          <div className="section-item">
            <img src={item.img} />
            <br />
            <span>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionWorkingChef;
